export enum ContactTopic {
  Undefined = "",
  General = "General Question",
  Demo = "Schedule a Demo",
  Meeting = "Request a Sales Call",
  UserSupport = "Existing User Support",
  Feedback = "Feedback",
  Notify = "Notify Me",
}

export class ContactUsRequest {
  name: string = "";
  email: string = "";
  topic: string = ContactTopic.General;
  message: string = "";

  constructor(props?: Partial<ContactUsRequest>) {
    Object.assign(this, props);
  }
}
